export default __webpack_public_path__ + "static/media/profile.fdbe9854.jpg";